import React, { useState, useEffect } from 'react';
import { json2xml } from 'xml-js';
import ConverterLayout from './ConverterLayout';
import { Alert } from '@mui/material';

function JsonToXml() {
  const [json, setJson] = useState(`{
  "root": {
    "item": [
      {
        "_attributes": { "id": "1" },
        "_text": "Value A"
      },
      {
        "_attributes": { "id": "2" },
        "_text": "Value B"
      }
    ]
  }
}`);
  const [xml, setXml] = useState('');
  const [error, setError] = useState('');

  const handleConvert = () => {
    setError('');
    if (!json.trim()) {
      setXml('');
      return;
    }

    try {
      const result = json2xml(json, { compact: true, spaces: 2 });
      setXml(result);
    } catch (e) {
      setError(e.message);
      setXml('');
    }
  };

  const handleSwap = () => {
    const tempXml = xml;
    setXml(json);
    setJson(tempXml);
    setError('');
  };

  const handleClear = () => {
    setJson('');
    setXml('');
    setError('');
  };

  // Auto-convert sample data on load
  useEffect(() => {
    handleConvert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <ConverterLayout
        title="JSON to XML Converter"
        description="Convert JSON data structures into XML formats. Free online tool that automatically parses JSON objects, arrays, and properties into valid XML."
        leftTitle="JSON"
        rightTitle="XML"
        leftLanguage="json"
        rightLanguage="xml"
        leftValue={json}
        setLeftValue={setJson}
        rightValue={xml}
        onConvert={handleConvert}
        onSwap={handleSwap}
        onClear={handleClear}
      />
    </>
  );
}

export default JsonToXml;